/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import ApiUtils from 'api/ApiUtils';
import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Row} from 'react-bootstrap';
import {
  type CategoryFormProps,
  type CategoryStatusList,
} from 'utils/TypeConfig';
import {useFormik} from 'formik';

import * as Yup from 'yup';
import {toast} from 'react-toastify';
import TooltipWithInfoIcon from 'Common/InfoTool';
import {tooltipMessage} from 'utils/Tooltips';
import {variables} from 'utils/constant';
import moment from 'moment';
import {isNumber} from 'lodash';
import {convertUTCToGST} from 'utils/dateTime';

interface Club {
  id: number;
  name: string;
}
const AfterPartyForm: React.FC<CategoryFormProps> = ({
  handleClose,
  setIsEditCategory,
  setIsAddCategory,
  editCategory,
  clubList,
}) => {
  console.log(
    '🚀 ~ editCategory:',
    editCategory,
    editCategory?.party_type !== '' ? parseInt(editCategory?.party_type) : 1,
  );
  const [club, setClub] = useState<Club[]>([]);
  const [status] = useState([
    {
      id: variables.AFTER_PARTY_ACTIVE_STATUS_ID,
      name: variables.AFTER_PARTY_ACTIVE_STATUS,
    },
    {
      id: variables.AFTER_PARTY_INACTIVE_STATUS_ID,
      name: variables.AFTER_PARTY_INACTIVE_STATUS,
    },
  ]);
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editCategory?.name !== '' ? editCategory?.name : '',
      party_type: isNumber(editCategory?.party_type)
        ? Number(editCategory?.party_type)
        : '',
      club_profile_id: editCategory?.club_profile_id
        ? editCategory?.club_profile_id
        : '',
      datetime: editCategory?.datetime !== '' ? editCategory?.datetime : '',
      location: editCategory?.location !== '' ? editCategory?.location : '',
      status: editCategory?.status !== '' ? editCategory?.status : '',
      after_party_max_capacity:
        editCategory?.after_party_max_capacity !== ''
          ? editCategory?.after_party_max_capacity
          : '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Puravida party name is required'),
      party_type: Yup.number()
        .typeError('Type is required')
        .required('Type is required'),
      // Conditionally validate `club_id` only if `type` is selected (not null/undefined)
      // club_profile_id: Yup.string().when('party_type', {
      //   // is: (val: string | null | undefined) => {
      //   //   console.log('val111', val);
      //   //   return val !== undefined && val !== null && val !== '' && val === '2';
      //   // },
      //   // then: schema => schema.required('Club is required'),
      //   // otherwise: schema => schema.notRequired(),

      //   is: (val: any) => val !== 1,
      //   then: schema => schema.required(`Club is required`),
      //   otherwise: schema => schema.notRequired(),
      // }),
      club_profile_id: Yup.string().when('party_type', {
        is: (val: number | null | undefined) => val == 2, // Validate only if party_type is 2
        then: schema => schema.required('Club is required'),
        otherwise: schema => schema.nullable(),
      }),
      datetime: Yup.string().required('Date is required'),
      status: Yup.string().required('Status is required'),
      after_party_max_capacity: Yup.number()
        .typeError('Max capacity must be a number') // Validates the input is a number
        .required('Max capacity is required')
        .min(1, 'Max capacity must be a positive number and greater than 0'), // Ensures it’s at least 0
    }),
    onSubmit: async (values: any): Promise<void> => {
      console.log('🚀 ~ onSubmit: ~ values:', values);

      try {
        const formData = {
          name: values.name,
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          party_type: parseInt(values?.party_type),
          club_profile_id:
            parseInt(values?.party_type) === 2 ? values.club_profile_id : null,
          status: values.status,
          datetime: moment(values.datetime).format('YYYY-MM-DD HH:mm'),
          location: values.location,
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          ...(editCategory?.id ? {id: editCategory?.id} : {}),
          // brand: selectedBrandOption.map((brand: any, index: number) => ({
          //   id: brand.value,
          // })),
          after_party_max_capacity: values.after_party_max_capacity,
        };

        if (typeof values?.image !== 'string') {
          (formData as any).image = values?.image;
        }
        console.log('🚀 ~ onSubmit: ~ formData:', formData);
        try {
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          const response: any = editCategory?.id
            ? await ApiUtils.updateAfterParty(formData)
            : await ApiUtils.addAfterParty(formData);
          // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/strict-boolean-expressions
          if (setIsEditCategory) {
            setIsEditCategory((prev: boolean) => !prev);
          }
          if (setIsAddCategory) {
            setIsAddCategory((prev: boolean) => !prev);
          }
          handleClose();
          toast.success(response?.message);
          // void getCategoryList();
        } catch (error: any) {
          toast.error(error?.response?.data?.message);
        }
      } catch (err: any) {
        toast.error(err);
      }
    },
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [type, setType] = useState('afterParty');
  useEffect(() => {
    const fetchClubList = async (): Promise<void> => {
      try {
        const requestBody = {
          type, // Add more fields as needed
        };
        const response: any = await ApiUtils.getClub(requestBody);
        console.log('🚀 ~ fetchCategoryList ~ response:', response?.data);
        setClub(response?.data);
      } catch (err) {
        console.error(err);
      }
    };

    void fetchClubList();
  }, []);
  console.log('validation', validation.errors);

  // console.log(editCategory?.id, 'categoryList');
  return (
    <div>
      <Form
        className="tablelist-form"
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit();
        }}>
        <Row>
          <div
            id="alert-error-msg"
            className="d-none alert alert-danger py-2"></div>
          <input type="hidden" id="id-field" />

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex align-items-center">
                <Form.Label htmlFor="party_type" className="me-2">
                  Type
                  <span className="text-danger required-mark">*</span>
                </Form.Label>
                <TooltipWithInfoIcon text={tooltipMessage.CategoryName} />
              </div>

              <Form.Check
                inline
                type="radio"
                id="puravida"
                label="Puravida Party "
                name="party_type"
                value="1"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                // checked={
                //   validation?.values?.party_type === 1 ||
                //   editCategory?.party_type === 1
                // }
                checked={
                  parseInt(validation?.values?.party_type) === 1 ||
                  (editCategory?.party_type === '1' &&
                    !validation?.values?.party_type)
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.party_type) &&
                    Boolean(validation.errors.party_type)
                  )
                }
              />
              <Form.Check
                inline
                type="radio"
                id="club"
                label="Club Party"
                name="party_type"
                value="2"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                // checked={
                //   validation?.values?.party_type === 2 ||
                //   editCategory?.party_type === 2
                // }
                checked={
                  parseInt(validation?.values?.party_type) === 2 ||
                  (editCategory?.party_type === '2' &&
                    !validation?.values?.party_type)
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.party_type) &&
                    Boolean(validation.errors.party_type)
                  )
                }
              />

              {Boolean(validation.touched.party_type) &&
              Boolean(validation.errors.party_type) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.party_type}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          {validation?.values &&
            parseInt(validation?.values?.party_type) === 2 && (
              <Col lg={12}>
                <div className="mb-3">
                  <div className="d-flex">
                    <Form.Label htmlFor="status-Field">Club</Form.Label>
                    <span className="text-danger required-mark">*</span>
                    <TooltipWithInfoIcon text={tooltipMessage.VenueStatus} />
                  </div>
                  <Form.Select
                    className="form-select"
                    name="club_profile_id"
                    id="status-Field"
                    onChange={e =>
                      validation.setFieldValue(
                        'club_profile_id',
                        e.target.value,
                      )
                    }
                    value={
                      validation.values.club_profile_id ||
                      (validation?.club_profile_id !== ''
                        ? validation?.club_profile_id
                        : '')
                    }
                    isInvalid={
                      !!(
                        validation.touched.club_profile_id &&
                        validation.errors.club_profile_id
                      )
                    }>
                    <option value="">--Select Club--</option>
                    {club?.map(
                      (
                        data: CategoryStatusList,
                        i: React.Key | null | undefined,
                      ) => (
                        <option key={i} value={data.id}>
                          {data.name}
                        </option>
                      ),
                    )}
                  </Form.Select>

                  {Boolean(validation.touched.club_profile_id) &&
                  Boolean(validation.errors.club_profile_id) ? (
                    <Form.Control.Feedback
                      className="required-mark"
                      type="invalid">
                      {validation.errors.club_profile_id}
                    </Form.Control.Feedback>
                  ) : null}
                </div>
              </Col>
            )}

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Puravida Party Name
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.AfterPartyName} />
              </div>
              <Form.Control
                type="text"
                id="club-name"
                placeholder="Enter Puravida Party Name"
                name="name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.name || editCategory?.name
                    ? editCategory?.name
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.name) &&
                    Boolean(validation.errors.name)
                  )
                }
              />
              {Boolean(validation.touched.name) &&
              Boolean(validation.errors.name) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.name}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">Date & Time :</Form.Label>
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.AfterPartyDateTime} />
              </div>

              <Form.Control
                type="datetime-local"
                id="datetime"
                name="datetime"
                min={convertUTCToGST(new Date().toISOString())}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.datetime}
                isInvalid={
                  Boolean(validation.touched.datetime) &&
                  !(validation.errors.datetime == null)
                }
              />
              {Boolean(validation.touched.datetime) && (
                <Form.Control.Feedback type="invalid">
                  {validation.errors.datetime as string}
                </Form.Control.Feedback>
              )}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">Status</Form.Label>
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.AfterPartyStatus} />
              </div>
              <Form.Select
                className="form-select"
                name="status"
                id="status-Field"
                onChange={e =>
                  validation.setFieldValue('status', e.target.value)
                }
                value={
                  validation.values.status ||
                  (editCategory?.status !== '' ? editCategory?.status : '')
                }
                isInvalid={
                  !!(validation.touched.status && validation.errors.status)
                }>
                <option value=" ">Status</option>
                {status?.map((data: CategoryStatusList, i) => (
                  <option key={i} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>

              {Boolean(validation.touched.status) &&
              Boolean(validation.errors.status) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.status}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">Location link</Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.AfterPartyLocation} />
              </div>
              <Form.Control
                type="text"
                id="location-link"
                placeholder="Enter location link"
                name="location"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.location || editCategory?.location
                    ? editCategory?.location
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.location) &&
                    Boolean(validation.errors.location)
                  )
                }
              />
              {Boolean(validation.touched.location) &&
              Boolean(validation.errors.location) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.location}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Max capacity(people)
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon
                  text={tooltipMessage.AfterPartyMaxCapacity}
                />
              </div>
              <Form.Control
                type="number"
                id="after_party_max_capacity"
                placeholder="Enter Max Capacity"
                name="after_party_max_capacity"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.after_party_max_capacity ||
                  editCategory?.after_party_max_capacity
                    ? editCategory?.after_party_max_capacity
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.after_party_max_capacity) &&
                    Boolean(validation.errors.after_party_max_capacity)
                  )
                }
              />
              {Boolean(validation.touched.after_party_max_capacity) && (
                <Form.Control.Feedback type="invalid">
                  {validation.errors.after_party_max_capacity as string}
                </Form.Control.Feedback>
              )}
            </div>
          </Col>

          <Col lg={12} className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <Button
                role="submitCategory"
                variant="dark"
                id="add-btn"
                type="submit">
                {editCategory?.id !== undefined
                  ? 'Edit Puravida Party'
                  : 'Add Puravida Party'}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default AfterPartyForm;
